/**
 * @class
 * @description Object that stores the plugin settings.
 * @exports Options
 */
export default class Options {
    /**
     * Constructs options object.
     * @param {constructionOptions} options JSON with the options to construct the balancer.
     */
    constructor(options) {
        // Manifest url of the content being played
        this.resource = '';
        // Optional override manifest
        this.overrideManifest = false;
        // Optional update every x seconds
        this.updateTime = 0;
        // Optional report every x seconds
        this.reportTime = 0;
        this.accountCode = options.accountCode;
        this.token = options.token;
        this.originCode = options.originCode;
        this.applicationCode = options.applicationCode;
        this.isLive = options.isLive || false;
        this.videoId = options.videoId;
        if (options.overrideManifest)
            this.overrideManifest = options.overrideManifest;
        if (options.updateTime) {
            this.updateTime = options.updateTime;
        }
        if (options.reportTime) {
            this.reportTime = options.reportTime;
        }
    }
}
